import React, { useState, useMemo, useCallback, useEffect } from 'react';
import axios from 'axios';

// import matrixData from '../matrixData.json'
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import { CommonConfig } from '../../../config/common-config';
import token from '../../../config/token';
import GeneralTable from './GeneralTable';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';

function PremissionTable() {
    const tokens = token();
    const initial_error = {
        isError: false,
        errorType: 0,
    };
    const matrix = [];

    const [data, setData] = useState(matrix);
    const [updateState, setUpdateState] = useState([]);
    const [column, setColumn] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [isError, setisError] = useState(initial_error);
    const [errorDetails, seterrorDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');

    useEffect(() => {
        setLoading(true);

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/roles-super-admin`, tokens)
            .then((response) => {
                setData(response.data);
            })
            .then((response) => {
                setLoading(false);
            })
            .catch((error) => {
                //console.log(error);
            });

        setData(matrix);
    }, [tokens]);

    const errorsDisplay = () => {
        if (isError.isError) {
            // if (isError.errorType === 1) return <Alert severity="error"> {errorDetails.message}</Alert>;
            if (isError.errorType === 1) {
                return (<div>{errorpop ? (<ErrorPopUp open={errorpop} showError={errorpop} title={errorDetails.message} />) : null} </div>);
            }
            if (isError.errorType === 2) {
                return (
                    <div>
                        {/* <Alert severity="error">
                            <AlertTitle>ERRORS</AlertTitle>{' '} */}
                        {errorpop ? (<ErrorPopUp open={errorpop} showError={errorpop} title={' '} />) : null}
                        {errorDetails.map((dataerr, i) => (
                            <div>
                                {i + 1}) {data}
                            </div>
                        ))}
                        {/* </Alert> */}
                    </div>
                );
            }
            if (isError.errorType === 3) {
                return (
                    <SuccessPopUp open={successpop} showSuccess={successpop} title="Matrix updated successfully" />
                    // <div>
                    //     <Alert severity="">
                    //         <AlertTitle>SUCCESS</AlertTitle> Updated Successfully
                    //     </Alert>
                    // </div>
                );
            }

            if (isError.errorType === 4) {
                return (
                    <LoaderPopUp showLoader={showLoader} />
                    // <div>
                    //     <Alert severity="info">
                    //         <AlertTitle>Connecting to server.........</AlertTitle>
                    //     </Alert>
                    // </div>
                );
            }
        }
    };

    const save = () => {
        setShowLoader(true);
        const update_error = {
            isError: true,
            errorType: 4,
        };
        setisError(update_error);
        // Update Stete Contain Data of Updated Columns
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/roles-super-admin`, updateState, tokens)
            .then((response) => {
                setSuccessPop(true);
                setTimeout(() => {
                    setSuccessPop(false);
                }, 1500);
                const update_error = {
                    isError: true,
                    errorType: 3,
                };
                setisError(update_error);
            })
            .catch((err) => {
                if (err.response) {
                    const err_result = err.response.data;

                    setErrorPop(true);
                    // setTimeout(() => {
                    //     setErrorPop(false);
                    // }, 1500);
                    if (err_result.hasOwnProperty('errors')) {
                        setErrorPop(true);
                        const update_error = {
                            isError: true,
                            errorType: 2,
                        };
                        setisError(update_error);
                        const error_all = err.response.data.errors.map((data) => data.field + ' ' + data.defaultMessage);
                        seterrorDetails(error_all);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 2000);
                    } else {
                        setErrorPop(true);
                        const update_error = {
                            isError: true,
                            errorType: 1,
                        };
                        setisError(update_error);
                        seterrorDetails(err.response.data);
                    }
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 2000);
                    //  alert(err.response.data.message);
                } else if (err.request) {
                    // client never received a response, or request never left
                } else {
                    // anything else
                }
            });
    };

    const updateData = useCallback((updated, roleCategory, roleText, value) => {
        setData((data) => {
            let roleCategoryIndex = -1;
            let roleTextIndex = -1;
            let featureIndex = -1;
            let subfeatureIndex = -1;

            roleCategoryIndex = data.findIndex((role) => {
                return role.roleCategory === roleCategory;
            });

            if (roleCategoryIndex !== -1) {
                roleTextIndex = data[roleCategoryIndex].roleText.findIndex((role) => role.roleText === roleText);
                if (roleTextIndex !== -1) {
                    featureIndex = data[roleCategoryIndex].roleText[roleTextIndex].feature.findIndex(
                        (role) => role.featureText === updated.features
                    );
                    if (featureIndex !== -1) {
                        subfeatureIndex = data[roleCategoryIndex].roleText[roleTextIndex].feature[featureIndex].subFeatures.findIndex(
                            (role) => role.subFeatureText === updated.sub_features
                        );
                    }
                }
            }

            if (roleCategoryIndex !== -1 || roleTextIndex !== -1 || featureIndex !== -1 || subfeatureIndex !== -1) {
                data[roleCategoryIndex].roleText[roleTextIndex].feature[featureIndex].subFeatures[subfeatureIndex].isActive = value;

                const updater = [
                    {
                        roleCategory: data[roleCategoryIndex].roleCategory,
                        roleText: [
                            {
                                ...data[roleCategoryIndex].roleText[roleTextIndex],
                                feature: [
                                    {
                                        ...data[roleCategoryIndex].roleText[roleTextIndex].feature[featureIndex],
                                        subFeatures: [
                                            data[roleCategoryIndex].roleText[roleTextIndex].feature[featureIndex].subFeatures[
                                            subfeatureIndex
                                            ],
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ];

                setUpdateState((state) => {
                    let updateRoleCategoryIndex = -1;
                    let updateRoleTextIndex = -1;
                    let updateFeatureIndex = -1;
                    let updateSubfeatureIndex = -1;

                    updateRoleCategoryIndex = state.findIndex((role) => {
                        return role.roleCategory === roleCategory;
                    });

                    if (updateRoleCategoryIndex !== -1) {
                        updateRoleTextIndex = state[updateRoleCategoryIndex].roleText.findIndex((role) => role.roleText === roleText);
                        if (updateRoleTextIndex !== -1) {
                            updateFeatureIndex = state[updateRoleCategoryIndex].roleText[updateRoleTextIndex].feature.findIndex(
                                (role) => role.featureText === updated.features
                            );
                            if (updateFeatureIndex !== -1) {
                                updateSubfeatureIndex = state[updateRoleCategoryIndex].roleText[updateRoleTextIndex].feature[
                                    updateFeatureIndex
                                ].subFeatures.findIndex((role) => role.subFeatureText === updated.sub_features);

                                if (updateSubfeatureIndex !== -1) {
                                    state[updateRoleCategoryIndex].roleText[updateRoleTextIndex].feature[
                                        updateFeatureIndex
                                    ].subFeatures.splice(updateSubfeatureIndex, 1, updater[0].roleText[0].feature[0].subFeatures[0]);
                                } else {
                                    state[updateRoleCategoryIndex].roleText[updateRoleTextIndex].feature[
                                        updateFeatureIndex
                                    ].subFeatures.push(...updater[0].roleText[0].feature[0].subFeatures);
                                }
                            } else {
                                state[updateRoleCategoryIndex].roleText[updateRoleTextIndex].feature.push(
                                    ...updater[0].roleText[0].feature
                                );
                            }
                        } else {
                            state[updateRoleCategoryIndex].roleText.push(...updater[0].roleText);
                        }
                    } else {
                        state.push(...updater);
                    }

                    return state;
                });
            }

            return data;
        });
    }, []);

    const update = useCallback(
        (index, value, roleCategory, roleText) => {
            setTableData((data) => {
                data[index][roleCategory + '_' + roleText] = value;
                updateData(data[index], roleCategory, roleText, value);
                return [...data];
            });
        },
        [updateData]
    );

    useMemo(() => {
        const column = [];
        column.push(
            {
                Header: 'Features',
                accessor: 'features',
            },
            {
                Header: 'Sub Features',
                accessor: 'sub_features',
            }
        );
        data.forEach((role) => {
            const subcolumn = role.roleText.map((text) => {
                return {
                    Header: text.roleText,
                    accessor: role.roleCategory + '_' + text.roleText,
                    Cell: ({ row }) => {
                        return (
                            <Checkbox
                                color="primary"
                                checked={row.values[role.roleCategory + '_' + text.roleText] ? true : false}
                                disabled={!(row.original[role.roleCategory + '_' + text.roleText + '_restricted'] ? true : false)}
                                onChange={(e) => update(row.index, e.target.checked, role.roleCategory, text.roleText)}
                            />
                            // <input
                            //     type="checkbox"
                            //     checked={row.values[role.roleCategory + '_' + text.roleText] ? true : false}
                            //     disabled={!(row.original[role.roleCategory + '_' + text.roleText + '_restricted'] ? true : false)}
                            //     onChange={(e) => update(row.index, e.target.checked, role.roleCategory, text.roleText)}
                            // />
                        );
                    },
                };
            });
            column.push({
                Header: role.roleCategory,
                accessor: role.roleCategory,
                columns: subcolumn,
            });
        });

        setColumn(column);
    }, [data, update]);

    useMemo(() => {
        let tableData = [];

        data.forEach((role) => {
            role.roleText.forEach((roleText) => {
                roleText.feature.forEach((feature) => {
                    const x = [];

                    feature.subFeatures.forEach((subFeature) => {
                        x.push({
                            features: feature.featureText,
                            sub_features: subFeature.subFeatureText,
                            [role.roleCategory + '_' + roleText.roleText]: subFeature.isActive,
                            [role.roleCategory + '_' + roleText.roleText + '_restricted']: subFeature.isRestrict,
                        });
                    });
                    tableData.push(...x);
                });
            });
        });

        const tableData2 = [];

        tableData.forEach((row) => {
            const index = tableData.findIndex((row1) => row1.features === row.features && row1.sub_features === row.sub_features);

            tableData2[index] = tableData2[index] ? { ...tableData2[index], ...row } : row;
        });

        setTableData(tableData2);
    }, [data]);

    return (
        <div
            className="container-fluid"
        // style={{ background: 'black', color: 'white' }}
        >
            <div className="row">
                {loading ? (<LoaderPopUp showLoader={loading} />)
                    // <h1>
                    //     <i>Loading...................</i>
                    // </h1>
                    : (
                        ''
                    )}
                {/* <hr></hr> */}
                <div className="col-md-12">
                    <GeneralTable column={column} data={tableData} />
                </div>
                {/* <hr></hr> */}
                {errorsDisplay()}
                <div className="m20">
                    <Button variant="contained" color="primary" className="btnMtrx" onClick={save}>
                        Update Matrix
                    </Button>
                    {/* <ButtonComp type="submit" className="btnMtrx" title="Update Matrix" onClick={save} /> */}
                </div>
            </div>
        </div>
    );
}

export default PremissionTable;
